// extracted by mini-css-extract-plugin
export default {"otpcontainer":"otpInput_otpcontainer__mOYwZ","otpinputs":"otpInput_otpinputs__kXP0J","otpInput":"otpInput_otpInput__52+kY"};